/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close dialog" |
*
* @param {Iconik_Metadata_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_close_label = /** @type {((inputs?: Iconik_Metadata_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "de") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "it") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "es") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Close dialog")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Close dialog")
	return /** @type {LocalizedString} */ ("Close dialog")
});